<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>验证码历史记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button type="primary" @click="showInfo">查看详情</el-button>
        <el-select v-model="tenantId">
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="refreshList({ page: 1, size: 25 })"
          >搜索</el-button
        >
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :show-close="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="谷歌验证码" prop="googleCode">
          <el-input v-model="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions } from "vuex";
import api from "./api";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "UserVerify",
  components: {
    UserList,
  },
  data() {
    return {
      dialogVisible: false,
      tenantId: 1,
      tenantList: [],
      form: {},
      rules: {
        googleCode: [
          { required: true, message: "请填写谷歌验证码", trigger: blur },
        ],
      },
    };
  },
  computed: {
    ...mapState("userVerify", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("userVerify", ["list"]),
    refreshList(data = {}) {
      this.list({
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    showInfo() {
      this.dialogVisible = true;
      this.form = {};
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          api
            .historyDetail({
              googleCode: this.form.googleCode,
            })
            .then((res) => {
              if (res.code == 0) {
                this.dialogVisible = false;
                this.form = {};
                this.$message({
                  message: "操作成功！",
                  type: "success",
                });
                this.$refs.form.resetFields();
                this.refreshList();
              }
            });
        }
      });
    },
    handleClose(done) {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      done();
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.refreshList();
  },
};
</script>

<style lang="less" scoped></style>
